var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAzxJREFUSEudlW2ITFEYx//PuXeQWZGSEMlbQigizVw2H0hJkv1IM7OSktbuzBBRV9rWrmt28UG2zB3ElxUflG/rZeeObbUS8mWTvMQqhbwzc8+jO7OzZu3M3sv5dk/n/H/n/z/Pcy7B42iIBDYJpjiIU0Yyc87ZFg1pm4nsw4Z5d1klGfKoj1go+BCExQCYGfUnUtbJWCjYIAlHE6bld3QOhLVJWZK7qj5/bNY7nvxy5jwDouHgIQKODhwoDxFMvSy41jCtiCOeA3cyMPnnr+zc05d6PnkG6DqErkPGw0GDgWgpxHFSiCvYRISIInlt8/nMk2IynhzEw8GNAC04bqZbKkFi29b57VGfR7ee635fGrsnQDQSOEVMewi0fyRITU2NMrPqzVYJMU4heaMlmXnjCtD1avXLi9xzANMKmVaGMImrArIPwBgQ1xvJTJsrIBrWthK4Y6jt8hAAew3TOuU5ooHTPwCwqEw5HzJMqzEaCTQS08FyF+9aRbGIFgdzS+UmKjiJhbXjAMeKkFInFSPaV6utkJLTAEaN1IzFO/kbYrNY0prqelwR0LA9OE8ouAVgqlu3D4NI5CRjYeKC1TcMsHenNkXJcru07V0Exe8R8k5CbE6YXXfjYW0N2/hgXEg/GnYHjria5ZsA5gP01LZz1SNAfjBwWRF0duz0dK/T6eWcDjoYKj7Y6OUhhA4ly7Hmi5mX7vE5Vx6qnqBSrrtw8vx4DfAxSGqCoLeDTlRch8QRI2VddhMe8hZFQ9pBIm4sTPJXW8ilJH0/BezHAI0vxjV+Vnf/t5cBvwTpOZWMtvZ0vxsoH9GQp1jiCxHqmOA0z+wBgRcqq9XHUref19eumqNI5Q4Ij4yktcEToL521URFKvdKBEv35cVzqiRpI5cwu14Vuhe7DTMzwRPAWdQQXj1dQDp1Xzy1Mz0oDlveYjATxGFIPgMF14yktd0zoARyFcBygB+o7NvixBILBe6AaHWJmFXl+75eb7//7Z8AxcVOVbWlbn8sfu/fFphhq6IT4DmFOkC/LRBsTVrP/gtQbtO+SGCqZOr8U8rUZJjp4itakeP6PyjdWbdj5WSf7bsCYB6ATYZp9bg5+A1go5UoNpOsoAAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.e831754ff4513ed5cca7a5adeecd9e06.svg";
export { ForwardRef as ReactComponent };